import React, { useState, useEffect, useRef } from "react";
import { useForm } from "react-hook-form";
import useRequest from "~/common/hooks/useRequest";
import { useTranslation } from "react-i18next";
import translation from "~/i18n";
// Components
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import PageHeader from "~/common/components/PageHeader";
import TabMenu from "~/common/components/TabMenu";

// Assets
import "~/assets/sass/pages/round/roundList/roundList.scss";
import "~/assets/sass/pages/round/common/roundDetailModal.scss";
import { API_STATE } from "~/common/constants/state";
// Pages
import PageIntro from "./component/PageIntro";
import List from "./component/List";
import RoundDetail from "./component/RoundDetail";
import RoundQuest from "./component/RoundQuest";
import { useNavigate } from "react-router";

const RoundList = () => {
	const navigate = useNavigate();
	const [currentTab, setCurrentTab] = useState("전체");
	const [roundListData, setRoundListData] = useState([]);
	const [roundDetailData, setRoundDetailData] = useState({});

	const tabMenuList = [
		{
			id: "전체",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title01"),
		},
		{
			id: "오픈대기",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title02"),
		},
		{
			id: "진행중",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title03"),
		},
		{
			id: "지원마감",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title04"),
		},
		{
			id: "심사중",
			title: translation.t("pages.round.RoundManage.container.tabMenuList.title05"),
		},
		{ id: "종료", title: translation.t("pages.round.RoundManage.List.status04") },
	];
	const roundAll = ["오픈대기", "진행중", "지원마감", "심사중", "종료"];

	const [inquiryPreModal, setInquiryPreModal] = useState(false);
	const inquiryOutputForm = useForm();
	const [roundDetailModal, setRoundDetailModal] = useState(false);
	const [roundState, setRoundState] = useState(roundAll);
	const [loadingPage, setLoadingPage] = useState(false);
	const [formData, setFormData] = useState({ title: "", status: roundState, page: 1, size: 12 });
	const [evalFormData, setEvalFormData] = useState({ roundIdx: 0, name: "", page: 1, size: 10 });

	const [oldStatus, setOldStatus] = useState(roundState);

	const listRequest = useRequest("post", "vc/round/search/judge");
	const viewRequest = useRequest("get", "vc/round/detail");

	const [load, setLoad] = useState(false);

	const ref = useRef();

	const checkIntersect = ([entry], observer) => {
		if (entry.isIntersecting) {
			setFormData((prevState) => ({
				...prevState,
				page: prevState.page + 1,
			}));
		}
	};

	useEffect(() => {
		listRequest.call(formData, "body", () => {
			if (!load) {
				let observer = new IntersectionObserver(checkIntersect, {
					root: null,
					threshold: 0.7,
					rootMargin: "20px",
				});

				observer.observe(ref.current);
				setLoad(true);
				return () => observer && observer.disconnect();
			}
		});
	}, [formData]);

	useEffect(() => {
		switch (listRequest.state) {
			case API_STATE.done:
				const requestCompanyData = listRequest.response?.data;
				if (oldStatus === formData.status) {
					setRoundListData((prevState) => [...prevState, ...requestCompanyData.list]);
				} else {
					setRoundListData(requestCompanyData.list);
				}

				setOldStatus(formData.status);

				break;
			default:
				break;
		}
	}, [listRequest.state, listRequest.response]);

	useEffect(() => {
		switch (viewRequest.state) {
			case API_STATE.done:
				const requestCompanyView = viewRequest.response?.data;
				setRoundDetailData(requestCompanyView);
				setRoundDetailModal(true);
				break;
			default:
				break;
		}
	}, [viewRequest.state, viewRequest.response, roundDetailData]);

	useEffect(() => {
		if (currentTab === "전체") {
			setFormData({ ...formData, status: roundAll, page: 1 });
		} else {
			setFormData({ ...formData, status: [currentTab], page: 1 });
		}
	}, [currentTab]);

	const viewDetail = (idx) => {
		viewRequest.call(idx, "path");
	};

	const viewEvalPage = (idx) => {
		navigate(`/round/list/evaluate/${idx}`);
	};

	return (
		<NavbarAndSidebarLayout menu={["round", "list"]} type={"main"} menuName={"round-list"}>
			<PageHeader />
			<TabMenu tabItem={tabMenuList} currentTab={currentTab} setCurrentTab={setCurrentTab} />
			<PageIntro />
			<List
				viewEvalPage={viewEvalPage}
				viewDetail={viewDetail}
				roundListData={roundListData}
				loadingPage={loadingPage}
			/>

			{/*----라운드 확인 모달*/}
			<RoundDetail
				roundDetailData={roundDetailData}
				roundDetailModal={roundDetailModal}
				setInquiryPreModal={setInquiryPreModal}
				setRoundDetailModal={setRoundDetailModal}
			/>

			{/*질의항목 미리보기 모달*/}
			<RoundQuest
				roundQuestList={roundDetailData?.query}
				inquiryPreModal={inquiryPreModal}
				setInquiryPreModal={setInquiryPreModal}
				inquiryOutputForm={inquiryOutputForm}
			/>


			<div ref={ref} />
		</NavbarAndSidebarLayout>
	);
};

export default RoundList;
